var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(272), __webpack_require__.e(662), __webpack_require__.e(527), __webpack_require__.e(547), __webpack_require__.e(653), __webpack_require__.e(942), __webpack_require__.e(315), __webpack_require__.e(453), __webpack_require__.e(887)]).then(() => (() => ((__webpack_require__(56887)))));
	},
	"./task_management/dashboard": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(272), __webpack_require__.e(653), __webpack_require__.e(21)]).then(() => (() => ((__webpack_require__(62021)))));
	},
	"./task_management/tasks": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(272), __webpack_require__.e(662), __webpack_require__.e(547), __webpack_require__.e(453), __webpack_require__.e(728)]).then(() => (() => ((__webpack_require__(80453)))));
	},
	"./task_management/projects": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(272), __webpack_require__.e(662), __webpack_require__.e(527), __webpack_require__.e(315)]).then(() => (() => ((__webpack_require__(99141)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});